import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
const DATOS: Array<{
  valor: string;
  label: string;
}> = [{
  valor: '633',
  label: 'páginas de material'
}, {
  valor: '400',
  label: 'actividades'
}, {
  valor: '21',
  label: 'días de plan diario'
}, {
  valor: '120',
  label: 'familias ya lo han probado'
}];
export function SocialProofTop() {
  return <section className="bg-white py-10 sm:py-12 px-5 border-b border-crema-alt" data-id="element-247" data-mp="1xheyxzdmmn9d">
      <div className="max-w-5xl mx-auto grid gap-8 md:grid-cols-[1.1fr_1.4fr] md:items-center" data-id="element-248" data-mp="1jmuqudb3bk6l">
        <div className="flex items-start gap-4" data-id="element-249" data-mp="1og6zvf3adie8">
          <span className="shrink-0 w-12 h-12 rounded-full bg-crema-alt flex items-center justify-center" data-id="element-250" data-mp="19qhwrebmv4bb">
            <BadgeCheckIcon className="w-6 h-6 text-dorado" aria-hidden="true" data-id="element-251" data-mp="1eob2k690xwb2" />
          </span>
          <div data-id="element-252" data-mp="10p1ll4czuy61">
            <p className="font-serif text-lg sm:text-xl font-semibold text-violeta" data-id="element-253" data-mp="10qcs3bxtqk0u">
              Revisado por una terapista ocupacional antes de publicarse
            </p>
            <div className="mt-2 flex items-center gap-2" data-id="element-254" data-mp="2i0w1njkue9t0">
              <span className="flex" aria-hidden="true" data-id="element-255" data-mp="2i3i81fvzyj9n">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-dorado fill-dorado" data-id="element-256" data-mp="2rzl8mhb7a9uh" data-mpi={i} />)}
              </span>
              <span className="text-sm text-tinta/70" data-id="element-257" data-mp="2n00csfrbuhlz">4,9 de 5 según las familias que ya lo usaron</span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3" data-id="element-258" data-mp="1zb7am1k43dix">
          {DATOS.map(dato => <div key={dato.label} className="rounded-2xl border border-crema-alt bg-crema px-3 py-4 text-center" data-id="element-259" data-mp="1udfjvav7dxgb">
              <div className="font-serif text-2xl sm:text-3xl font-bold text-violeta leading-none" data-id="element-260" data-mp="249ikudebjq1o">
                {dato.valor}
              </div>
              <div className="mt-1 text-[11px] sm:text-xs text-tinta/70 leading-tight" data-id="element-261" data-mp="1giljfuk5gb4o">
                {dato.label}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}